import { NgModule } from '@angular/core';
import { ShowAuthedDirective } from './directives/show-authed.directive';
import { AuthGuard } from './services/auth-guard.service';
import { JwtAuthenticationService } from './services/jwt-authentication.service';
import { LaravelPassportService } from './services/laravel-passport.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthorizationInterceptor } from '../interceptors/authorization.interceptor';

@NgModule({
  declarations: [ShowAuthedDirective],
  exports: [ShowAuthedDirective],
  providers: [
    JwtAuthenticationService,
    LaravelPassportService,
    AuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationInterceptor,
      multi: true,
    },
  ],
})
export class AuthenticationModule {}
